import React from "react";
import { Box, Typography, Switch } from "@mui/joy";

interface SuperApplyToggleProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  text: string;
}

const SuperApplyToggle: React.FC<SuperApplyToggleProps> = ({
  checked,
  onChange,
  text,
}) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography level="label">{text}</Typography>
      <Switch
        checked={checked}
        onChange={onChange}
        sx={{
          "--Switch-trackBackground": checked
            ? "#34C759 !important"
            : "#EDEFF3 !important",
          "--Switch-thumbBackground": "#fff",
        }}
      />
    </Box>
  );
};

export default SuperApplyToggle;
